import ProcessProductCard from "components/OrderDetail/ProcessProducts/ProcessProductCard/ProcessProductCard"
import { IProcessProductsList } from "interfaces/IProcessProductsList"
import styled from "styled-components"

const GridStyled = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 1rem;
  margin-top: 1rem;

  @media (min-width: 768px) {
    grid-template-columns: repeat(3, 1fr);
  }
`

const ProcessProductsList = ({ processItems = [], onClickEditItem }: IProcessProductsList) => {
  return (
    <GridStyled className="padding-content">
      {processItems.map(({ sku, isConfirm, name, custom, quantity }) => (
        <ProcessProductCard
          key={sku}
          isConfirm={isConfirm}
          name={name}
          sku={sku}
          custom={custom}
          quantity={quantity}
          onClickEditItem={onClickEditItem}
        />
      ))}
    </GridStyled>
  )
}

export default ProcessProductsList
